import { defineStore } from 'pinia'

/**
 * Tracks which (event, dedupKey) pairs have already fired in the current app session.
 *
 * The set intentionally persists across navigation — per the bet, "tab-backs"
 * (navigating away and returning via the browser back button) must not refire
 * view events. So leaving /deliveries and coming back does NOT fire a second
 * Deliveries Page Viewed, and revisiting an already-seen order does NOT fire
 * Order Viewed again.
 *
 * The set only clears on sign-out, via useAnalytics().reset().
 */
export const useAnalyticsSessionStore = defineStore('analyticsSession', () => {
  // Set of composite keys (`${eventName}:${dedupKey}` or just `eventName`) already fired.
  const sessionDedup = new Set<string>()

  const resetSession = (): void => {
    sessionDedup.clear()
  }

  const hasFiredInSession = (key: string): boolean => sessionDedup.has(key)

  const markFiredInSession = (key: string): void => {
    sessionDedup.add(key)
  }

  return {
    resetSession,
    hasFiredInSession,
    markFiredInSession,
  }
})
